import { render, staticRenderFns } from "./MonthAllowancesPlanFloatBtns.vue?vue&type=template&id=61d77de8&"
import script from "./MonthAllowancesPlanFloatBtns.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports